export function handleResponse(response) {
  if (response.status && response.status === 401) {
    sessionStorage.clear();
    window.location.href = "/login";
  }
  return response.data;
}

export function handleError(error) {
  if (error.status && error.status === 401) {
    sessionStorage.clear();
    window.location.href = "/login";
  }

  if (error.response && error.response.data) {
    return error.response.data;
  }

  return error;
}
